import React from 'react';

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://47a880c1cbc6163edc87a5fc36746620@o4508858350043136.ingest.us.sentry.io/4508930425880576',
  integrations: [
    Sentry.replayIntegration({
      flushMinDelay: 2000,
      flushMaxDelay: 2500,
      minReplayDuration: 0,
    }),
  ],
  allowUrls: [
    /https:\/\/app\.blankslatetechnologies\.com/i,
    /https:\/\/app-dev\.blankslatetechnologies\.com/i,
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    // 'localhost',
    /^https:\/\/svc\.blankslatetech\.co\/sreo/,
    /^https:\/\/svc-dev\.blankslatetech\.co\/sreo/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  beforeSend(event) {
    const url = window.location.href;
    if (url.includes('app-blankslate.il') || url.includes('localhost')) {
      return null;
    }

    return event;
  },
});

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
